import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class MarketConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getMarketEndpoint(): string {
		return this.configService.get((x) => x.core.market.endpoints!.market, "i18n/v1/markets");
	}

	/**
	 * This field is auto generated at runtime, which means it should't
	 * have been placed here in the first place.
	 *
	 * todo: OBGB-11417, please track the task and refactor all fields
	 */
	getLanguageCode(): string {
		return this.configService.get((x) => x.core.market.languageCode);
	}
}
